import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatiqInputErrorTypes } from '@dat/datiq-components-pkg/utils';
import { isControlValueARange, isDateInvalidMax } from './datiq-datepicker-validator-utils';

export const maxDate: (date: string | Date) => ValidatorFn = (
    date: string | Date
): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const invalid: boolean = isControlValueARange(control)
        ? isDateInvalidMax(date, control?.value?.start) || isDateInvalidMax(date, control?.value?.end)
        : isDateInvalidMax(date, control?.value)
        return invalid
            ? { [DatiqInputErrorTypes.DateMax]: {actual: control?.value, max: date} }
            : null;
    };
};

